import { render, staticRenderFns } from "./twoListEditor.vue?vue&type=template&id=c86de158&scoped=true"
import script from "./twoListEditor.vue?vue&type=script&lang=js"
export * from "./twoListEditor.vue?vue&type=script&lang=js"
import style0 from "./twoListEditor.vue?vue&type=style&index=0&id=c86de158&prod&lang=css"
import style1 from "./twoListEditor.vue?vue&type=style&index=1&id=c86de158&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86de158",
  null
  
)

export default component.exports